module.exports = __webpack_public_path__ + "65bcbc899f379216109acd0b6c494618.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/system/assets/css/fonts/font-awesome/fonts/fontawesome-webfont.svg?v=4.0.3
 ** module id = 345
 ** module chunks = 0
 **/